/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { Banner as ChromaBanner } from '@iag-packages/chroma-react/lib/components';

import THEME from 'theme';
import { SCREEN } from 'scenes/common/types/screen';

const BannerWrapper = styled.div`
  .c-banner {
    background-color: ${THEME.BACKGROUND.CARD};
    height: 125px;

    @media (min-width: ${SCREEN.SMALL}px) {
      height: 280px;
    }
  }
`;

export const Banner = ({ ...props }) => (
  <BannerWrapper>
    <ChromaBanner {...props} />
  </BannerWrapper>
);

export default Banner;
